import saleFullcont from "./sale-fullcont.html";

const dialog = require("../../../../../../components/dialog/dialog");
const fullcontEntity = require("../../../../../../components/fullcont/fullcont-entity");
const fullcontHandler = require("../../../../../../components/fullcont/fullcont-handler");
const backControl = require("../../../../../../js/back-control"); // Ajusta la ruta según tu estructura

const saleDt = require("../../sale/sale-dt");
const saleMenu = require("./sale-menu");
const handler = require("./sale-fullcont-handler");
const { formCopy } = require("./sale-fullcont-form");
const { form } = require("./sale-fullcont-form");
const { saleMT } = require("./sale-fullcont-multitable");
const timeDate = require("../../../../../../js-handler/time-date");
const settings = require("../../../../../../js-handler/settings");
const restriction = require("./sale-fullcont-restriction");
const notification = require("./sale-fullcont-notification");

/****************ELEMENTS*****************/
var htmlFc2 = {};
var HTMLwasSelected = false;
var input_send_email = false;
var scrimFullcont2

function HTMLselect(detail) {
  fullcontHandler.HTMLselect(
    "sale", //database table name****
    "sale", //dest entity on js
    "sale-fullcont3",
    saleFullcont,
    form,
    formCopy,
    saleMT,
    editDialog,
    deleteDialog,
    dtCall,
    htmlFc2
  );

  HTMLwasSelected = true;
  // htmlFc2.hasFiles   = true
  // fullcontHandler.rightsControl(htmlFc2)
} /**/

export function start(detail) {
  //console.log('sale-dt 5>', detail)

  if (!HTMLwasSelected) {
    HTMLselect(detail);
  }

  obj[detail.act].start(detail);
} /**/

const obj = {
  addOne: {
    start: (detail) => {
      addOne(detail, htmlFc2);
    },
  },
  addOnePrint: {
    start: (detail) => {
      addOnePrint(detail, htmlFc2);
    },
  },
  cancelEdit: {
    start: (detail) => {
      fullcontEntity.cancelEdit(detail, htmlFc2);
    },
  },
  deleteEntity: {
    start: (detail) => {
      deleteEntity(detail, htmlFc2);
    },
  },
  deleteFromDialog: {
    start: (detail) => {
      deleteFromDialog(detail, htmlFc2);
    },
  },
  discard: {
    start: (detail) => {
      fullcontHandler.discard(detail, htmlFc2);
    },
  },
  fullcontOptions: {
    start: (detail) => {
      saleMenu.start(detail, "htmlDt", htmlFc2);
    },
  },
  hide: {
    start: (detail) => {
      fullcontEntity.hide(detail, htmlFc2);
    },
  },
  prepareAdd: {
    start: (detail) => {
      fullcontEntity.prepareAdd(detail, htmlFc2, process);
    },
  },
  prepareEdit: {
    start: (detail) => {
      fullcontHandler.prepareEdit(detail, htmlFc2);
    },
  },
  saveFromDialog: {
    start: (detail) => {
      saveFromDialog(detail);
    },
  },
  selectOne: {
    start: (detail) => {
      fullcontEntity.selectOne(
        detail,
        htmlFc2,
        process_required_field_select_one
      );
    },
  },
  selectOneNoCheck: {
    start: (detail) => {
      fullcontEntity.selectOneNoCheck(
        detail,
        htmlFc2,
        process_required_field_select_one
      );
    },
  },
  update: {
    start: (detail) => {
      update(detail);
    },
  },
  updatePrint: {
    start: (detail) => {
      updatePrint(detail);
    },
  },
  otherFieldCustomer: {
    start: (detail) => {
      handler.otherFieldCustomer(detail, htmlFc2);
    },
  },
  otherFieldItem: {
    start: (detail) => {
      handler.otherFieldItem(detail, htmlFc2);
    },
  },
  calculate_values: {
    start: (detail) => {
      handler.calculate_values(detail, htmlFc2);
    },
  },
  calculateGrandTotal: {
    start: (detail) => {
      calculateGrandTotal();
    },
  },
  required_field: {
    start: (detail) => {
      handler.required_field(htmlFc2);
    },
  },
  pdfMenuFullcont: {
    start: (detail) => {
      handler.pdfMenuFullcont("print");
    },
  },
  pdfFullcontPackSlip: {
    start: (detail) => {
      handler.pdfFullcontPackSlip(detail, htmlFc2);
    },
  },
  addOneFromDialog: {
    start: (detail) => {
      fullcontEntity.addOne(detail, htmlFc2, process_required_field);
    },
  },
  addOnePrintFromDialog: {
    start: (detail) => {
      fullcontEntity.addOne(detail, htmlFc2, process_required_field_print);
    },
  },
  updateFromDialog: {
    start: (detail) => {
      updateFromDialog(detail);
    },
  },
  updatePrintFromDialog: {
    start: (detail) => {
      updatePrintFromDialog(detail);
    },
  },
  shippingnow: {
    start: (detail) => {
      handler.shippingnow(htmlFc2);
    },
  },
  insertshippingdatetime: {
    start: (detail) => {
      handler.insertshippingdatetime(htmlFc2);
    },
  },
  showcost: {
    start: (detail) => {
      handler.showcost(htmlFc2);
    },
  },
  showreturn: {
    start: (detail) => {
      handler.showreturn(htmlFc2);
    },
  },
  verifyQtyItem: {
    start: (detail) => {
      handler.verifyQtyItem(htmlFc2);
    },
  },
  calculatepaymentdue: {
    start: (detail) => {
      handler.calculatepaymentdue(htmlFc2);
    },
  },
  calculate_values_p_vs_lost: {
    start: (detail) => {
      handler.calculate_values_p_vs_lost(detail, htmlFc2);
    },
  },
  beforeAutocomplete: {
    start: (detail) => {
      handler.beforeAutocomplete(detail, htmlFc2);
    },
  },
  otherFieldItemLost: {
    start: (detail) => {
      handler.otherFieldItemLost(detail, htmlFc2);
    },
  },
  showFullcont: {
    start: (detail) => {
      showFullcont(detail);
    },
  },
  hide2: {
    start: (detail) => {
      hide2(detail);
    },
  },
}; /**/

function showFullcont(detail, callback) {
  const isWideScreen = window.innerWidth >= 1800;

  let fullcont = document.getElementById(detail.id);
  if (isWideScreen) {
    fullcontEntity.selectOneNoCheck(
      detail,
      htmlFc2,
      process_required_field_select_one
    );
    isscrimFullcont2TemporarilyHidden = true;
  } else {
    fullcontEntity.selectOneNoCheck(
      detail,
      htmlFc2,
      process_required_field_select_one
    );
    scrimFullcont2 = document.getElementById("scrim_fullcont2");
    scrimFullcont2.classList.add("scrim-show");
    isscrimFullcont2TemporarilyHidden = true;
  }

  // fullcont.remove(); // Elimina de #sale-page
  const pageAccounts = document.getElementById(`${detail.dest}-page`);
  pageAccounts.appendChild(fullcont); // Lo agrega al body
}

function hide2(detail) {
  //console.log('hide',  detail)
  console.log(scrimFullcont2)
  var elem;

  if (detail.id != undefined) {
    elem = document.getElementById(detail.id);
  } else {
    elem = detail.fullcontHTML;
  }

  // andry
  hideAnimation(elem, scrimFullcont2);
  isscrimFullcont2TemporarilyHidden = false;

  //remove to the url
  backControl.hashSub({ toHide: `fullcont-${detail.id}` });
  //   cleanHash();
  return;
} /**/

function cleanHash() {
  // Obtener el hash actual y dividirlo
  const currentHash = window.location.hash.replace("#", "").split("|");
  // Filtrar elementos vacíos y fullcont
  const cleanedHash = currentHash.filter(
    (item) => item && !item.startsWith("fullcont-")
  );

  // Si hay elementos válidos, reconstruir el hash
  if (cleanedHash.length > 0) {
    window.location.hash = cleanedHash.join("|");
  } else {
    // Si no hay elementos, limpiar completamente el hash
    history.replaceState(null, null, " ");
  }
}

function hideAnimation(elem, scrimFullcont) {
  //console.log(`hideAnimation`, elem)

  const size = window.innerWidth;

  elem.classList.add("fullcont-hide");

  if (size < 1800) {
    scrimFullcont.classList.add("scrim-hide");
  }

  remove(() => {
    elem.classList.remove("fullcont-show");
    elem.classList.remove("fullcont-hide");
    scrimFullcont.classList.remove("scrim-show");
    scrimFullcont.classList.remove("scrim-hide");
  });
}

function remove(callback) {
  setTimeout(() => {
    callback();
  }, 250);
}

//function to send
function editDialog() {
  dialog.start({ act: "show", id: "saveChanges", entity: "sale" });
}

function deleteDialog(detail) {
  dialog.start({
    act: "show",
    dest: "sale",
    id: "deleteElem",
    entity: "sale",
    dbid: detail.dbid,
  });
}

function dtCall(act, result) {
  saleDt.start({ act: act, row: result });
}

async function addOne(detail, htmlFc2) {
  input_send_email = htmlFc2.fullcontHTML.querySelector(
    "#sale_form_send_email3 input"
  ).checked;

  if (!(await handler.validated(detail, htmlFc2, "add"))) {
    if ((await handler.checkCreditLimit(detail, htmlFc2, "add")) != true) {
      fullcontEntity.addOne(detail, htmlFc2, process_required_field);
    }
  }
}

async function addOnePrint(detail, htmlFc2) {
  if (!(await handler.validated(detail, htmlFc2, "addPrint"))) {
    if ((await handler.checkCreditLimit(detail, htmlFc2, "addPrint")) != true) {
      fullcontEntity.addOne(detail, htmlFc2, process_required_field_print);
    }
  }
}

function deleteFromDialog(detail, htmlFc2) {
  fullcontEntity.deleteFromDialog(detail, htmlFc2);
  setTimeout(() => {
    saleDt.start({ dest: "sale", elem: "dt", act: "select", entity: "sale" });
  }, 900);
}

//Function to set default values to fullcont fields when creating a record is pressed
function setDefaultValue(htmlFc2) {
  let sale_date = htmlFc2.fullcontHTML.querySelector(
    "#sale_form_sale_date3 input"
  );
  sale_date.value = timeDate.convertDateToInput();

  let sale_statement = htmlFc2.fullcontHTML.querySelector(
    "#sale_form_sale_statement3 textarea"
  );
  sale_statement.value = settings.getData().sale_statement;

  let sale_footer = htmlFc2.fullcontHTML.querySelector(
    "#sale_form_sale_footer3 textarea"
  );
  sale_footer.value = settings.getData().sale_footer;

  let sale_shipping_status = htmlFc2.fullcontHTML.querySelector(
    "#sale_form_shipping_status3 select"
  );
  sale_shipping_status.value = "preparing";

  let day_default = "30";
  let sale_form_terms = htmlFc2.fullcontHTML.querySelector(
    "#sale_form_terms3 select"
  );
  sale_form_terms.value = day_default;

  let due_date = htmlFc2.fullcontHTML.querySelector(
    "#sale_form_due_date3 input"
  );
  due_date.value = timeDate.convertDateToInput(
    new Date().setDate(new Date().getDate() + parseInt(day_default))
  );

  let sale_showcost = htmlFc2.fullcontHTML.querySelector("#showcost3");
  sale_showcost.checked = false;

  let sale_showreturn = htmlFc2.fullcontHTML.querySelector("#showreturn3");
  sale_showreturn.checked = false;
  console.log(htmlFc2);
  htmlFc2.formCopy.forEach((element) => {
    if (element.name == "sale_date") {
      element.value = sale_date.value;
    }

    if (element.name == "due_date") {
      element.value = due_date.value;
    }

    if (element.name == "sale_statement") {
      element.value = sale_statement.value;
    }

    if (element.name == "sale_footer") {
      element.value = sale_footer.value;
    }

    if (element.name == "shipping_status") {
      element.value = sale_shipping_status.value;
    }

    if (element.name == "terms") {
      element.value = sale_form_terms.value;
    }

    if (element.name == "grand_total") {
      element.value = "0.00";
    }

    if (element.name == "total_profit_pct") {
      element.value = "0.00 / %0.00";
    }
  });
}

function process_required_field(data, result) {
  handler.required_field(htmlFc2);
  restriction.evaluation(htmlFc2, result.restriction);
  notification.start(data, result, htmlFc2);

  if (input_send_email) {
    handler.pdfMenuFullcont("sendemail");
  }
  handler.fill_InventoryStock(data);

  let return_mt = htmlFc2.fullcontHTML.querySelector("#return3");
  return_mt.classList.remove("dn");
  handler.showcost(htmlFc2);
}

function process_required_field_saveFromDialog(data = undefined, result) {
  handler.required_field(htmlFc2);
  if (data != undefined) {
    restriction.evaluation(htmlFc2, result.restriction);
    notification.start(data, result, htmlFc2);
    handler.fill_InventoryStock(data);
    handler.pdfMenuFullcont("print_sendmail");
    let return_mt = htmlFc2.fullcontHTML.querySelector("#return3");
    return_mt.classList.remove("dn");
    handler.showcost(htmlFc2);
  }
}

function process_required_field_update(data = undefined, result) {
  handler.required_field(htmlFc2);
  if (data != undefined) {
    restriction.evaluation(htmlFc2, result.restriction);
    notification.start(data, result, htmlFc2);
    handler.dtgenerator(result, htmlFc2);
    if (input_send_email) {
      handler.pdfMenuFullcont("sendemail");
    }
    handler.fill_InventoryStock(data);
    handler.showcost(htmlFc2);
  }
}

function process_required_field_select_one(data, result) {
  handler.required_field(htmlFc2);
  handler.fill_InventoryStock(data);
  restriction.evaluation(htmlFc2, result.restriction);
  notification.start(data, result, htmlFc2);
  handler.dtgenerator(result, htmlFc2);
  handler.getemailTraking(result);

  let sale_showcost = htmlFc2.fullcontHTML.querySelector("#showcost3");
  sale_showcost.checked = false;
  let event = new Event("change");
  sale_showcost.dispatchEvent(event);

  let return_mt = htmlFc2.fullcontHTML.querySelector("#return3");
  return_mt.classList.remove("dn");

  let sale_showreturn = htmlFc2.fullcontHTML.querySelector("#showreturn3");
  sale_showreturn.checked = false;

  event = new Event("change");
  sale_showreturn.dispatchEvent(event);
}

function process_required_field_print(data, result) {
  handler.required_field(htmlFc2);
  restriction.evaluation(htmlFc2, result.restriction);
  notification.start(data, result, htmlFc2);

  handler.dtgenerator(result, htmlFc2);
  handler.pdfMenuFullcont("print_sendmail");

  handler.fill_InventoryStock(data);

  let return_mt = htmlFc2.fullcontHTML.querySelector("#return3");
  return_mt.classList.remove("dn");

  handler.showcost(htmlFc2);
}

function process() {
  setDefaultValue(htmlFc2);
  handler.required_field(htmlFc2);
  handler.cleandtfullcont(htmlFc2);
  handler.calculateGrandTotal(htmlFc2);
  handler.calculateGrandTotalReturn(htmlFc2);
}

async function saveFromDialog(detail) {
  input_send_email = htmlFc2.fullcontHTML.querySelector(
    "#sale_form_send_email3 input"
  ).checked;

  setTimeout(async () => {
    if (
      !(await handler.validated(
        detail,
        htmlFc2,
        htmlFc2.fullcontHTML.classList.contains("mode-add") == true
          ? "add"
          : "update"
      ))
    ) {
      let mode =
        htmlFc2.fullcontHTML.classList.contains("mode-add") == true
          ? "add"
          : "update";
      fullcontEntity.saveFromDialog(
        detail,
        htmlFc2,
        mode == "add"
          ? process_required_field_saveFromDialog
          : process_required_field_update
      );
    }
  }, 500);
}

async function update(detail) {
  input_send_email = htmlFc2.fullcontHTML.querySelector(
    "#sale_form_send_email3 input"
  ).checked;
  if (!(await handler.validated(detail, htmlFc2, "update"))) {
    fullcontEntity.update(detail, htmlFc2, process_required_field_update);
  }
}

async function updatePrint(detail) {
  if (!(await handler.validated(detail, htmlFc2, "updatePrint"))) {
    fullcontEntity.update(detail, htmlFc2, process_required_field_print);
  }
}

function calculateGrandTotal() {
  setTimeout(() => {
    handler.calculateGrandTotal(htmlFc2);
  }, 900);
}

function updateFromDialog(detail) {
  input_send_email = htmlFc2.fullcontHTML.querySelector(
    "#sale_form_send_email3 input"
  ).checked;
  // para que se pase el boton update en vez del boton update del dialogo
  // ya que esto da error al momento de quitar el icono de error de los tab
  detail.ev = { target: htmlFc2.fullcontHTML.querySelector("#updateButton3") };
  fullcontEntity.update(detail, htmlFc2, process_required_field_update);
}

function updatePrintFromDialog(detail) {
  // para que se pase el boton update en vez del boton update del dialogo
  // ya que esto da error al momento de quitar el icono de error de los tab
  detail.ev = { target: htmlFc2.fullcontHTML.querySelector("#updateButton3") };
  fullcontEntity.update(detail, htmlFc2, process_required_field_print);
}

async function deleteEntity(detail, htmlFc2) {
  if (await handler.processpayment(htmlFc2, "update", detail.dbid.join(","))) {
    return true;
  } else {
    fullcontEntity.deleteEntity(detail, htmlFc2);
  }
}

/********CONTROL WINDOW RESIZE AND FULLCONT/SCRIM****************/
//avoid potencial error that the user resize the scrim :)
var isscrimFullcont2TemporarilyHidden = false; //andry

window.addEventListener("resize", () => {
  const size = window.innerWidth;

  if (size > 1200 && isscrimFullcont2TemporarilyHidden) {
    // Comportamiento para scrim_fullcont2
    // andry
    console.log(scrimFullcont2)
    if (size > 1800) {
      scrimFullcont2.classList.add("scrim-hide");
      scrimFullcont2.classList.remove("scrim-show");
    } else {
      scrimFullcont2.classList.add("scrim-show");
      scrimFullcont2.classList.remove("scrim-hide");
    }
  }
});

window.addEventListener("resize", () => {
  const size = window.innerWidth;

  // Comportamiento para scrim_fullcont2
  // andry
  if (size > 1800) {
    cleanHash();
  }
});
